var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPatientRoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9085 6.3691C4.44661 6.45302 4.01736 6.67581 3.68068 7.01249C3.24477 7.4484 3 8.0395 3 8.65591V10.001C3 10.5528 3.44724 11 3.99904 11C5.39237 11 8.59997 11 9.9933 11C10.5451 11 10.9923 10.5528 10.9923 10.001V8.65591C10.9923 8.0395 10.7476 7.4484 10.3117 7.01249C9.97498 6.67581 9.54573 6.45302 9.08384 6.3691C9.23969 6.0564 9.32727 5.70408 9.32727 5.3311C9.32727 4.04467 8.2826 3 6.99617 3C5.70974 3 4.66507 4.04467 4.66507 5.3311C4.66507 5.70408 4.75265 6.0564 4.9085 6.3691ZM8.62794 6.99517C8.20768 7.40778 7.63123 7.6622 6.99617 7.6622C6.36111 7.6622 5.78467 7.40778 5.3644 6.99517C5.35108 6.99684 5.33776 6.9975 5.32444 6.9975C4.88453 6.9975 4.4626 7.17233 4.1519 7.48337C3.84086 7.79441 3.66603 8.21633 3.66603 8.65591V10.001C3.66603 10.1848 3.81522 10.334 3.99904 10.334H9.9933C10.1771 10.334 10.3263 10.1848 10.3263 10.001V8.65591C10.3263 8.21633 10.1515 7.79441 9.84045 7.48337C9.52974 7.17233 9.10781 6.9975 8.6679 6.9975C8.65458 6.9975 8.64126 6.99684 8.62794 6.99517ZM6.99617 3.66603C7.91529 3.66603 8.66124 4.41231 8.66124 5.3311C8.66124 6.25022 7.91529 6.99617 6.99617 6.99617C6.07705 6.99617 5.3311 6.25022 5.3311 5.3311C5.3311 4.41231 6.07705 3.66603 6.99617 3.66603Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32821 8.34498H7.9952C7.81138 8.34498 7.66219 8.49417 7.66219 8.678C7.66219 8.86182 7.81138 9.01101 7.9952 9.01101H8.32821V9.34403C8.32821 9.52785 8.4774 9.67704 8.66123 9.67704C8.84505 9.67704 8.99424 9.52785 8.99424 9.34403V9.01101H9.32726C9.51108 9.01101 9.66027 8.86182 9.66027 8.678C9.66027 8.49417 9.51108 8.34498 9.32726 8.34498H8.99424V8.01197C8.99424 7.82815 8.84505 7.67896 8.66123 7.67896C8.4774 7.67896 8.32821 7.82815 8.32821 8.01197V8.34498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatientRoom);
export default __webpack_public_path__ + "static/media/icon-patient-room.062ace28956a99256beb64bda28f45ea.svg";
export { ForwardRef as ReactComponent };